import React, { useState } from "react";
import "./largeAccount.css";
import CustomModal from "../../../components/Modal/CustomModal";

const LargeAccount = () => {
  const [country, setCountry] = useState("");
  const [operator, setOperator] = useState("");
  const [error, setError] = useState(false);
  const [addAccountModal, setAddAccountModal] = useState(false);
  const [editAccountModal, setEditAccountModal] = useState(false);
  const [viewAccountModal, setViewAccountModal] = useState(false);
  const [deleteAccountModal, setDeleteAccountModal] = useState(false);
  const [addAccountForm, setAddAccountForm] = useState({
    country: "",
    operator: "",
    shortCode: "",
  });
  const [addAccountFormError, setAddAccountFormError] = useState(false);

  const [editAccountForm, setEditAccountForm] = useState({
    country: "KSA" || "",
    operator: "test" || "",
    shortCode: "1234567890" || "",
    status: "Active" || "InActive",
  });
  const [editAccountFormError, setEditAccountFormError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!country || !operator) {
      setError(true);
    } else {
      setError(false);
      alert("Success");
    }
  };

  const handleAddAccountSubmit = (e) => {
    e.preventDefault();
    if (
      !addAccountForm.country ||
      !addAccountForm.operator ||
      !addAccountForm.shortCode
    ) {
      setAddAccountFormError(true);
    } else {
      setAddAccountFormError(false);
      alert("Success");
    }
  };

  const handleEditAccountSubmit = (e) => {
    e.preventDefault();
    if (
      !editAccountForm.country ||
      !editAccountForm.operator ||
      !editAccountForm.shortCode ||
      !editAccountForm.status
    ) {
      setEditAccountFormError(true);
    } else {
      setEditAccountFormError(false);
      alert("Success");
    }
  };

  return (
    <div class="content-wrapper">
      <section class="content">
        <div class="row">
          <div class="col-md-12">
            <div class="box">
              <div class="box-header">
                <div class="row">
                  <div class="col-md-6">
                    <nav aria-label="breadcrumb">
                      <ol class="breadcrumb breadcrumb_bg">
                        <li class="breadcrumb-item">
                          <a class="breadcrumb_1">Setting & Configuration</a>
                        </li>
                        <li
                          class="breadcrumb-item active breadcrumb_2"
                          aria-current="page"
                        >
                          Large Account
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <div class="col-md-6 mt_3">
                    <div class="btn-group float-right">
                      <button
                        type="button"
                        class="btn btn-primary btn-raised btn-flat pull-right mx-2"
                        onClick={() => setViewAccountModal(true)}
                      >
                        View
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary btn-raised btn-flat pull-right mx-2"
                        onClick={() => setEditAccountModal(true)}
                      >
                        Edit
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary btn-raised btn-flat pull-right mx-2"
                        onClick={() => setDeleteAccountModal(true)}
                      >
                        Delete
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary btn-raised btn-flat pull-right"
                        onClick={() => setAddAccountModal(true)}
                      >
                        Add Large Account
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="box-body" style={{ marginTop: "30px" }}>
                <form onSubmit={handleSubmit}>
                  <div class="row ">
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label class="font-weight-bold">
                          Country <sup class="text-danger">*</sup>
                        </label>
                        <select
                          class={`form-control ${
                            error && !country ? "is-invalid" : ""
                          }`}
                          name="country"
                          formControlName="country"
                          value={country}
                          onChange={(e) => setCountry(e.target.value)}
                        >
                          <option value="" selected>
                            --Select Country --
                          </option>
                          <option value="2">KSA</option>
                        </select>
                        {error && !country && (
                          <span class="text-danger">Country is required</span>
                        )}
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="form-group">
                        <label class="font-weight-bold">
                          Operator<sup class="text-danger">*</sup>
                        </label>
                        <select
                          class={`form-control ${
                            error && !operator ? "is-invalid" : ""
                          }`}
                          name="Operator"
                          formControlName="Operator"
                          value={operator}
                          onChange={(e) => setOperator(e.target.value)}
                        >
                          <option value="" selected>
                            Select Operator
                          </option>
                          <option value="test">test operator</option>
                        </select>
                        {error && !operator && (
                          <span class="text-danger">Operator is required</span>
                        )}
                      </div>
                    </div>

                    <div class="col-md-4 text-right my-4">
                      <div class="form-group">
                        <button type="submit" class="btn btn-primary">
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                <div>
                  <div class="row mt-2">
                    <div class="col-md-12">
                      {/* <table 
                                        class="table table-bordered table-striped table-sm" >
                                        <thead>
                                            <tr class="table-info" >
                                                <th>id</th>
                                                <th>Operator Name</th>
                                                <th>Operator Code</th>

                                                <th>Short code</th>
                                                <th>Created On</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let Ser of searchlargeres.largeAccounts">
                                                <td> {{Ser.id}}</td>
                                             <td>{{name}}</td>
                                                <td>{{Ser.operatorCode}}</td>

                                                <td>{{Ser.shortCode}}</td>
                                                <td>{{Ser.createdOn | date:'dd-MMM-yyyy'}}</td>
                                                <td>
                                                    <div class="form-control no_bg no-border no_img p-0">
                                                        <!-- <label class="switch">
                                                        <input type="checkbox" name="enable" #enable="ngModel" (click)=" statusChange(Ser) "
                                                           [(ngModel)]="Ser.status"  [ngModelOptions]="{standalone: true}">
                                                        <span class="slider round"></span>
                                                    </label> -->
                                                        <button type="button" title="View Details" name="enable"
                                                            style="margin-right: 2px;" (click)=" viewAcc(Ser)"
                                                            class="btn btn-primary btn-raised btn-flat pull-right no-margin margin_right_10 btn_pad mr-2"><i
                                                                class="fa fa-eye"></i></button>
                                                        <span style="margin-left: 3px; visibility: hidden;"></span>
                                                        <button type="button" name="enable" title="editDetails"
                                                            style="margin-left:2px"
                                                            class="btn btn-danger btn-raised btn-flat pull-right no-margin btn_pad "
                                                            (click)=" editAcc(Ser)"><i
                                                                class="fa fa-pencil"></i></button>
                                                        <span style="margin-left: 3px; visibility: hidden;"></span>
                                                        <button type="button" name="enable" title="Delete Account"
                                                            (click)="delete(Ser)"
                                                            class="btn btn-danger btn-raised btn-flat btn_pad"><i
                                                                class="fas fa-times"></i></button>


                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Add Large Account Modal */}
      <CustomModal
        show={addAccountModal}
        onHide={() => {
          setAddAccountModal(false);
          setAddAccountFormError(false);
          setAddAccountForm({
            country: "",
            operator: "",
            shortCode: "",
          });
        }}
        title="Add Large Account"
        size="lg"
        dialogClassName="custom-modal-class"
      >
        <form onSubmit={handleAddAccountSubmit}>
          <div class="row ">
            <div class="col-sm-4">
              <div class="form-group">
                <label class="font-weight-bold">
                  Country <sup class="text-danger">*</sup>
                </label>
                <select
                  class={`form-control ${
                    addAccountFormError && !addAccountForm.country
                      ? "is-invalid"
                      : ""
                  }`}
                  name="country"
                  formControlName="country"
                  value={addAccountForm.country}
                  onChange={(e) =>
                    setAddAccountForm({
                      ...addAccountForm,
                      country: e.target.value,
                    })
                  }
                >
                  <option value="" selected>
                    --Select Country --
                  </option>
                  <option value="KSA">KSA</option>
                </select>
                {addAccountFormError && !addAccountForm.country && (
                  <span class="invalid-feedback d-block error">
                    Country is required
                  </span>
                )}
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <label class="font-weight-bold">
                  Operator<sup class="text-danger">*</sup>
                </label>
                <select
                  class={`form-control ${
                    addAccountFormError && !addAccountForm.operator
                      ? "is-invalid"
                      : ""
                  }`}
                  name="Operator"
                  formControlName="Operator"
                  value={addAccountForm.operator}
                  onChange={(e) =>
                    setAddAccountForm({
                      ...addAccountForm,
                      operator: e.target.value,
                    })
                  }
                >
                  <option value="" selected>
                    Select Operator
                  </option>
                  <option value="test">Operator</option>
                </select>
                {addAccountFormError && !addAccountForm.operator && (
                  <span class="invalid-feedback d-block error">
                    Operator is required
                  </span>
                )}
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <label class="font-weight-bold">Short Code</label>
                <input
                  type="text"
                  class={`form-control ${
                    addAccountFormError && !addAccountForm.shortCode
                      ? "is-invalid"
                      : ""
                  }`}
                  name="Scode"
                  formControlName="Scode"
                  value={addAccountForm.shortCode}
                  onChange={(e) =>
                    setAddAccountForm({
                      ...addAccountForm,
                      shortCode: e.target.value,
                    })
                  }
                />
                {addAccountFormError && !addAccountForm.shortCode && (
                  <span class="invalid-feedback d-block error">
                    Enter Short Code
                  </span>
                )}
              </div>
            </div>
          </div>
          <div class="modal-footer pb-0 border-0 d-flex justify-content-between px-0 mx-0">
            <button
              type="button"
              class="btn btn-danger m-0"
              data-dismiss="modal"
              onClick={() => {
                setAddAccountModal(false);
                setAddAccountFormError(false);
                setAddAccountForm({
                  country: "",
                  operator: "",
                  shortCode: "",
                });
              }}
            >
              Close
            </button>
            <button type="submit" class="btn btn-primary m-0">
              Submit
            </button>
          </div>
        </form>
      </CustomModal>

      {/* edit Large Account Modal */}
      <CustomModal
        show={editAccountModal}
        onHide={() => {
          setEditAccountModal(false);
          setEditAccountFormError(false);
        }}
        title="Edit Large Account"
        size="lg"
        dialogClassName="custom-modal-class"
      >
        <form onSubmit={handleEditAccountSubmit}>
          <div class="row ">
            <div class="col-sm-3">
              <div class="form-group">
                <label class="font-weight-bold">
                  Country <sup class="text-danger">*</sup>
                </label>
                <select
                  disabled
                  class={`form-control ${
                    editAccountFormError && !editAccountForm.country
                      ? "is-invalid"
                      : ""
                  }`}
                  name="country"
                  formControlName="country"
                  value={editAccountForm.country}
                  onChange={(e) =>
                    setEditAccountForm({
                      ...editAccountForm,
                      country: e.target.value,
                    })
                  }
                >
                  <option value="" selected>
                    --Select Country --
                  </option>
                  <option value="KSA">KSA</option>
                </select>
                {editAccountFormError && !editAccountForm.country && (
                  <span class="invalid-feedback d-block error">
                    Country is required
                  </span>
                )}
              </div>
            </div>

            <div class="col-sm-3">
              <div class="form-group">
                <label class="font-weight-bold">
                  Operator<sup class="text-danger">*</sup>
                </label>
                <select
                  disabled
                  class={`form-control ${
                    editAccountFormError && !editAccountForm.operator
                      ? "is-invalid"
                      : ""
                  }`}
                  name="Operator"
                  formControlName="Operator"
                  value={editAccountForm.operator}
                  onChange={(e) =>
                    setEditAccountForm({
                      ...editAccountForm,
                      operator: e.target.value,
                    })
                  }
                >
                  <option value="" selected>
                    Select Operator
                  </option>
                  <option value="test">Operator</option>
                </select>
                {editAccountFormError && !editAccountForm.operator && (
                  <span class="invalid-feedback d-block error">
                    Operator is required
                  </span>
                )}
              </div>
            </div>

            <div class="col-sm-3">
              <div class="form-group">
                <label class="font-weight-bold">Short Code</label>
                <input
                  type="text"
                  class={`form-control ${
                    editAccountFormError && !editAccountForm.shortCode
                      ? "is-invalid"
                      : ""
                  }`}
                  name="Scode"
                  formControlName="Scode"
                  value={editAccountForm.shortCode}
                  onChange={(e) =>
                    setEditAccountForm({
                      ...editAccountForm,
                      shortCode: e.target.value,
                    })
                  }
                />
                {editAccountFormError && !editAccountForm.shortCode && (
                  <span class="invalid-feedback d-block error">
                    Enter Short Code
                  </span>
                )}
              </div>
            </div>

            <div class="col-sm-3 d-inline-flex">
              <div class="form-group form-group-special switch ">
                <label class="font-weight-bold"> Status</label>
                <label class="switch">
                  <input
                    type="checkbox"
                    name="enable"
                    checked={editAccountForm.status === "Active"}
                    onChange={(e) =>
                      setEditAccountForm({
                        ...editAccountForm,
                        status: e.target.checked ? "Active" : "InActive",
                      })
                    }
                  />
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </div>
          <div class="modal-footer pb-0 border-0 d-flex justify-content-between px-0 mx-0">
            <button
              type="button"
              class="btn btn-danger m-0"
              data-dismiss="modal"
              onClick={() => {
                setEditAccountModal(false);
                setEditAccountFormError(false);
              }}
            >
              Close
            </button>
            <button type="submit" class="btn btn-primary m-0">
              Submit
            </button>
          </div>
        </form>
      </CustomModal>

      {/* view Large Account Modal */}
      <CustomModal
        show={viewAccountModal}
        onHide={() => {
          setViewAccountModal(false);
        }}
        title="View Large Account"
        size="xl"
        dialogClassName="custom-modal-class"
      >
        <table class="table table-bordered table-striped table-sm table_popup table-sm">
          <tbody>
            <tr>
              <th class="border_r_0" style={{ width: "90px" }}>
                id:
              </th>
              <td
                class="border_l_0"
                style={{ wordBreak: "break-all", width: "90px" }}
              >
                1
              </td>
              <th class="border_r_0" style={{ width: "90px" }}>
                Operator Code:
              </th>
              <td
                class="border_l_0"
                style={{ wordBreak: "break-all", width: "90px" }}
              >
                123
              </td>
              <th class="border_r_0" style={{ width: "90px" }}>
                Status:
              </th>
              <td
                class="border_l_0"
                style={{ wordBreak: "break-all", width: "90px" }}
              >
                <span class="badge badge-danger">InActive</span>
                <span class="badge badge-success">Active</span>
              </td>
            </tr>
            <tr>
              <th class="border_r_0" style={{ width: "90px" }}>
                Short Code :
              </th>
              <td
                class="border_l_0"
                style={{ wordBreak: "break-all", width: "90px" }}
              >
                1234567890
              </td>
              <th class="border_r_0" style={{ width: "90px" }}>
                Created Date:
              </th>
              <td
                class="border_l_0"
                style={{ wordBreak: "break-all", width: "90px" }}
              >
                12-03-2025
              </td>
              <th class="border_r_0" style={{ width: "90px" }}>
                Time:
              </th>
              <td
                class="border_l_0"
                style={{ wordBreak: "break-all", width: "90px" }}
              >
                12:00:00
              </td>
            </tr>
          </tbody>
        </table>
      </CustomModal>

      {/* Delete Large Account Modal */}
      <CustomModal
        show={deleteAccountModal}
        onHide={() => {
          setDeleteAccountModal(false);
        }}
        title="Delete Account"
        size="md"
        dialogClassName="custom-modal-class"
      >
        <form class="form-horizontal">
          <div class="card">
            <div class="card-body p-2">
              <p class="card_text mb-0 text-center font-weight-light pt-4 pb-4 msg_text">
                Are you Sure you want to delete? Short Code:-1234567890
              </p>
            </div>
          </div>
          <div class="modal-footer pb-0 border-0 d-flex justify-content-between px-0 mx-0">
            <button type="button" class="btn btn-danger m-0" data-dismiss="modal">
              Cancel
            </button>
            <button type="submit" class="btn btn-primary m-0">
              Confirm
            </button>
          </div>
        </form>
      </CustomModal>
    </div>
  );
};

export default LargeAccount;
